export default import.meta.ROLLUP_FILE_URL_LtSC0nSM_GZhdfCx$QsMwQ